import { useTableFiltersQuery } from '@modules/layout/hooks';

import type { TableFiltersQuery } from '@modules/layout/hooks';

export type SchoolsListFilters<ForForm extends boolean = false> = {
    number?: ForForm extends true ? string : number;
    shortName?: string;
    locationRegionId?: string;
    locationId?: string;
};

export type SchoolsListFiltersFormValues = SchoolsListFilters<true>;

export type SchoolsTableFiltersQuery = Omit<TableFiltersQuery, 'filters'> & {
    filters: TableFiltersQuery['filters'] & SchoolsListFilters;
};

const useSchoolsTableFiltersQuery = (): SchoolsTableFiltersQuery => {
    const { filters, query, ...otherTableFiltersQuery } = useTableFiltersQuery();

    const result = {
        filters: {
            ...filters,
            number: query.number ? Number(query.number) : undefined,
            shortName: query.shortName ? String(query.shortName) : undefined,
            locationRegionId: query.locationRegionId ? String(query.locationRegionId) : undefined,
            locationId: query.locationId ? String(query.locationId) : undefined,
        },
        query,
        ...otherTableFiltersQuery,
    };

    return result;
};

export { useSchoolsTableFiltersQuery };
